// extracted by mini-css-extract-plugin
export default {"SettingsTabs":"index__SettingsTabs__WN_YR"};